<template>
  <div class="mobile-small screen">
    <BreadCrumbs />
    <header class="header-1">
      <div class="header_container-1">
        <div class="player_data-1">
          <div class="escudo_equipo-1">
            <img class="logo_equipo-1" v-if="image" :src="image" alt="logo_equipo" />
          </div>
          <div class="info-1">
            <div class="info_container-1">
              <div class="name-1">
                <div class="tigres-de-la-uanl valign-text-middle">{{ team.team_name }}</div>
              </div>
              <div class="container_info">
                <div
                  class="puntos-1"
                  v-if="points && seasonType === 0 && ![1784, 1741, 1512, 881].includes(selectedSeason)"
                >
                  <div class="nationality valign-text-middle">{{ points }}</div>
                  <div class="nationality-1 valign-text-middle avenirnextltpro-medium-white-9px">
                    PTS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header_info_menu-1 avenirnextltpro-demi-normal-white-6px">
          <div class="btn-1" :class="value === 4 ? 'active' : ''" @click="onChangeSection(4)">
            <div class="defensivo-1 valign-text-middle">RESUMEN</div>
          </div>
          <div class="btn-1" :class="value === 1 ? 'active' : ''" @click="onChangeSection(1)">
            <div class="defensivo-1 valign-text-middle">POSESIÓN</div>
          </div>
          <div class="btn-1" :class="value === 2 ? 'active' : ''" @click="onChangeSection(2)">
            <div class="defensivo-1 valign-text-middle">OFENSIVO</div>
          </div>
          <div class="btn-1" :class="value === 3 ? 'active' : ''" @click="onChangeSection(3)">
            <div class="defensivo-1 valign-text-middle">DEFENSIVO</div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BreadCrumbs from '@/components/Sections/HeaderFigmaTeams/BreadCrumbs';
export default {
  name: 'MobileSmall',
  components: {
    BreadCrumbs,
  },
  props: {
    points: {
      type: Number,
      required: false,
      default: 0,
    },
    team: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      isHover: false,
      section: 4,
      selectedSeason: 0,
      sections: [
        {
          id: 4,
          title: 'analysis_type.summary',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen_unselected.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen.svg',
          ],
          selected: false,
        },
        {
          id: 1,
          title: 'analysis_type.possession',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-white.svg',
          ],
          selected: false,
        },
        {
          id: 2,
          title: 'analysis_type.offensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-white.svg',
          ],
          selected: false,
        },
        {
          id: 3,
          title: 'analysis_type.defensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-white.svg',
          ],
          selected: false,
        },
      ],
    };
  },
  watch: {
    value(newId) {
      this.changeSection(newId);
    },
  },
  computed: {
    ...mapState('filterGeneral', ['seasonType']),
    sectionsIds() {
      return this.sections.map(i => i.id);
    },
    image() {
      if (this.team.logo) {
        return `https://golstatsimages.blob.core.windows.net/teams-150/${this.team.logo.split('/').pop()}`;
      } else {
        return '';
      }
    },
  },
  methods: {
    changeSection(sectionId) {
      if (this.sectionsIds.includes(sectionId)) {
        this.sections.forEach(e => (e.selected = false));
        const section = this.sections.find(s => s.id === sectionId);
        if (section) {
          section.selected = true;
          return true;
        }
      }
      return false;
    },
    onChangeSection(id) {
      this.section = id;
      let result = this.changeSection(id);
      if (result) this.$emit('input', id);
    },
  },
  mounted() {
    this.changeSection(this.value);
  },
  created() {
    const selectedSeason = window.localStorage.getItem('seasonSelected');
    if (selectedSeason) {
      this.selectedSeason = Number(selectedSeason);
    }
  },
};
</script>

<style>
.headerfigmaTeams .mobile-small {
  align-items: center;
  border: 1px none;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  position: relative;
  margin-top: -10px;
}

.headerfigmaTeams .header-1 {
  width: 100%;
  align-items: center;
  align-self: stretch;
  background: linear-gradient(
    180deg,
    rgb(6.85, 91.11, 137.06) 0%,
    rgba(1.63, 68.84, 105.5, 1) 51.8%,
    rgba(1.42, 14.25, 21.25, 1) 100%
  );
  background-color: transparent;
  border-radius: 8.2px;
  display: inline-block;
  gap: 0px;
  height: auto;
  margin: 0 auto;
  mix-blend-mode: normal;
  padding: 7.72px 12px 6.75px;
  position: relative;
  margin-top: 8px;
}
/* @media (max-width: 330px) {
  .header-1 {
    width: 99%;
  }
} */
/* @media (max-width: 330px) {
  .header-1 {
    width: 96%;
  }
} */
/* @media (max-width: 320px) {
  .header-1 {
    width: 94%;
  }
}
@media (max-width: 310px) {
  .header-1 {
    width: 92%;
  }
} */
.headerfigmaTeams .header_container-1 {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 11px;
  position: relative;
}

.headerfigmaTeams .player_data-1 {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 10.61px;
  position: relative;
}
.headerfigmaTeams .escudo_equipo-1 {
  align-items: center;
  display: flex;
  gap: 3.27px;
  height: 42.9px;
  justify-content: flex-end;
  position: relative;
  width: 41px;
}

.headerfigmaTeams .logo_equipo-1 {
  height: 42.64px;
  margin-bottom: -1.2px;
  margin-left: -0.32px;
  margin-right: -1.32px;
  min-width: 42.64px;
  object-fit: cover;
  position: relative;
}

.headerfigmaTeams .info-1 {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4.82px;
  height: 47.2px;
  justify-content: center;
  padding: 2px 0px 0px;
  position: relative;
}

.headerfigmaTeams .info_container-1 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  position: relative;
}

.headerfigmaTeams .name-1 {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  padding: 3px 0px;
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .tigres-de-la-uanl {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xxl);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 13px;
  margin-top: -1px;
  position: relative;
  text-shadow: 0px 1.93px 1.93px #162b3436;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .container_info {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 7.23px;
  position: relative;
}

.headerfigmaTeams .puntos-1 {
  align-items: center;
  border: 1px solid;
  border-color: var(--white-2);
  border-radius: 6px;
  display: flex;
  gap: 7px;
  padding: 5px 16px;
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .nationality {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: 13px;
  font-weight: 400;
  letter-spacing: -0.13px;
  line-height: 7.7px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .nationality-1 {
  letter-spacing: -0.09px;
  line-height: 7.7px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .header_info_menu-1 {
  align-items: center;
  align-self: stretch;
  border-radius: 5.79px;
  display: flex;
  gap: 6px;
  justify-content: center;
  position: relative;
}

.headerfigmaTeams .btn-1 {
  align-items: center;
  align-content: center;
  border-radius: 5.3px;
  display: flex;
  font-family: 'Avenir-Demi';
  flex: 1;
  font-size: 8px;
  flex-direction: column;
  gap: 7px;
  justify-content: center;
  padding: 6.5px 0px;
  position: relative;
  box-shadow: 0 0.5px 2.4px 0 rgba(27, 45, 63, 0.14);
  border: solid 0.5px #23b0ff;
}
@media screen and (max-width: 420px) {
  .headerfigmaTeams .btn-1 {
    padding: 6px 0px;
    padding-top: 8px;
    font-size: 7px;
  }
}
@media screen and (max-width: 340px) {
  .headerfigmaTeams .btn-1 {
    font-size: 6px;
    padding: 5px 0px;
    padding-top: 7px;
  }
}
.headerfigmaTeams .btn-1:hover {
  background-color: #23b0ff;
  cursor: pointer;
}

.headerfigmaTeams .radiografa-1,
.headerfigmaTeams .defensivo-1 {
  letter-spacing: -0.18px;
  line-height: 4px;
  margin-top: -0.48px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}
</style>
